import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router";
import axios from "../axios";

const AuthContext = React.createContext();

function useAuth() {
  return useContext(AuthContext);
}

function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [globalNotification, setGlobalNotification] = useState();
  const [env, setEnv] = useState();

  useEffect(async () => {
    if (localStorage.getItem("currentUser")) {
      let token = JSON.parse(localStorage.getItem("currentUser")).token;
      const verifyToken = await axios.post("/verifytoken", {
        token: token,
      });

      if (verifyToken.data !== "geçersiz jwt") {
        setCurrentUser(JSON.parse(localStorage.getItem("currentUser")));
        console.log("token geçerli");
      } else {
        console.log("geçersiz token");
        logout();
      }
    }
    getEnv();
    setLoading(false);
  }, []);

  function getEnv() {
    const result = axios.get("/env");
    setEnv(result);
  }

  async function login(username, password) {
    const response = await axios.post("/login", {
      username: username,
      password: password,
    });
    if (
      response.data !== "hatalı giriş" &&
      response.data !== "hesap etkinleştirilmemiş"
    ) {
      setCurrentUser(response.data);
      localStorage.setItem("currentUser", JSON.stringify(response.data));
    }
    return response.data;
  }

  async function register(username, email, password) {
    const response = await axios.post("/register", {
      username: username,
      email: email,
      password: password,
    });
    return response;
  }

  function logout() {
    setCurrentUser();
    localStorage.removeItem("currentUser");
  }

  async function resetPassword(password, newPassword) {
    if (localStorage.getItem("currentUser")) {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));

      const verifyToken = await axios.post("/resetPassword", {
        token: currentUser.token,
        username: currentUser.username,
        password: password,
        newPassword: newPassword,
      });

      if (verifyToken.data === "geçersiz jwt") {
        return "geçersiz token";
      } else if (verifyToken.data === "hatalı giriş") {
        console.log("hatalı giriş");
        logout();
        history.push("/login");
        setGlobalNotification(
          "Mevcut şifreniz yanlış. Lütfen tekrar giriş yapınız."
        );
      } else if (verifyToken.data === "şifre değiştirildi") {
        return "şifre değiştirildi";
      } else {
        console.log("hatalı işlem");
      }
    }
  }

  async function recoverAccount(email) {
    const result = await axios.post("/recoverAccount", {
      email: email,
    });

    return result.data;
  }

  async function newPassword(password, token) {
    const verifyToken = await axios.post("/newPasswordUpdate", {
      token: token,
      password: password,
    });

    if (verifyToken.data === "geçersiz jwt") {
      return "geçersiz token";
    } else if (verifyToken.data === "şifre sıfırlandı") {
      return "şifre sıfırlandı";
    } else {
      console.log("hata oluştu");
    }
  }

  function setGlobalNot(not) {
    setGlobalNotification(not);
  }

  const value = {
    currentUser,
    login,
    logout,
    register,
    resetPassword,
    recoverAccount,
    newPassword,
    globalNotification,
    setGlobalNot,
    env,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export { AuthProvider, useAuth };
